var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"w3-button w3-text-theme",attrs:{"type":"button"},on:{"click":function($event){_vm.login()}}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'sign-in-alt']}}),_c('span',[_vm._v(" "+_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }